module.exports = __webpack_public_path__ + "media/error_sound.7556c5e2.mp3";